export * from './add-room-group';
export * from './assign-room';

import { AddRoomGroupComponent } from './add-room-group';
import { AssignRoomToRoomGroupsComponent } from './assign-room';

export const RoomGroupOrganisms = [
    AddRoomGroupComponent,
    AssignRoomToRoomGroupsComponent
]